// extracted by mini-css-extract-plugin
export default {"main":"Insurances_main__itdOV","ltr":"Insurances_ltr__rDGHr","rtl":"Insurances_rtl__Pglkr","first":"Insurances_first__hDmBM","firstPara":"Insurances_firstPara__PdFHk"};